// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"DV-dv"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15 8H21V16H15V8Z"}},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 12C12 13.1258 11.6279 14.1647 11 15.0005C10.0878 16.2147 8.6356 17 7 17C5.3644 17 3.91223 16.2147 3 15.0005C2.37209 14.1647 2 13.1258 2 12C2 10.8742 2.37209 9.83526 3 8.99951C3.91223 7.78534 5.3644 7 7 7C8.6356 7 10.0878 7.78534 11 8.99951C11.6279 9.83526 12 10.8742 12 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 12H15M12 12C12 9.23858 9.76142 7 7 7M12 12C12 14.7614 9.76142 17 7 17M7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7M7 17C5.36398 17 3.9122 16.2137 3.00001 14.999V21H11V14.999C10.0878 16.2137 8.63602 17 7 17ZM7 7C8.63574 7 10.0878 7.78565 11 9V3H3.00001L3 8.99951C3.91221 7.78517 5.36426 7 7 7ZM15 8H21V16H15V8Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DvIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dv',
    ref,
    icon: element,
  },
));

DvIcon.displayName = 'DvIcon';

export default DvIcon;
